import {
  NAV_SET_MENU_OPEN,
  NAV_SET_SIDE_MENU_OPEN
} from './constants';

export const setMobileMenuOpen = isOpen => ({
  type: NAV_SET_MENU_OPEN, isOpen
});

export const setSideMenuOpen = isOpen => ({
  type: NAV_SET_SIDE_MENU_OPEN, isOpen
});
